//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import config from '~/config'
import ModalConfirmation from '~/components/Landing/ModalConfirmation.vue'
import NavOffset from '~/components/Shared/NavOffset.vue'

export default {
  components: { ModalConfirmation, NavOffset },
  async fetch() {
    this.$store.commit('loading', true)
    const filters = {
      _sort: 'created_at:DESC',
      _where: {
        active: true,
      },
      populate: ['locations', 'card_image'],
    }

    const sliders = await this.$repository.slider.findAll({
      _sort: 'order:ASC',
      is_people: true,
    })

    this.carouselItems = sliders.map((slider) => ({
      img: {
        alt: slider.image_description
          ? slider.image_description
          : slider.image_web_jpg.name,
        imageWebWebp: `${this.baseUrl}${slider.image_web_webp.url}`,
        imageWebJpg: `${this.baseUrl}${slider.image_web_jpg.url}`,
        imageMobileWebp: `${this.baseUrl}${slider.image_mobile_webp.url}`,
        imageMobileJpg: `${this.baseUrl}${slider.image_mobile_jpg.url}`,
      },
      title: slider.title,
      description: slider.subtitle,
      button: {
        label: slider.button,
        link: slider.button_route || '',
      },
    }))

    this.jobSeekerFairs = await this.$repository.jobSeekerFair.findAll(filters)
    this.$store.commit('loading', false)
  },
  data() {
    return {
      mounted: false,
      modalVisible: false,
      carouselItems: [],
      jobSeekerFairs: [],
      isVisiblePilotModal: false,
      flag: false,
      baseUrl: config.gcsBaseurl,
    }
  },
  computed: {
    menuData() {
      return [
        { name: 'Personas', link: '/', active: true },
        { name: 'Empresas', link: '/empresas', active: false },
      ]
    },
  },

  mounted() {
    this.mounted = true
    const css = `
      html {
        scroll-behavior: smooth;
      }
    `
    this.styleTag = document.createElement('style')
    this.styleTag.appendChild(document.createTextNode(css))
    document.head.appendChild(this.styleTag)
    document.documentElement.classList.remove('has-aside-left')
    document.documentElement.classList.remove('has-aside-mobile-transition')
    document.documentElement.classList.remove('has-navbar-fixed-top')
    document.documentElement.classList.remove('has-aside-expanded')
  },
  destroyed() {
    this.styleTag.remove()
  },
  methods: {
    goToPanel() {
      this.$router.push('/inicio')
    },
    goToRegister() {
      this.$router.push('/registro')
    },
    goToMessage() {
      this.$router.push('#messages')
    },
    togglePilotModalReq() {
      this.isVisiblePilotModal = !this.isVisiblePilotModal
    },
  },
  layout: 'person',
}
